<template>
  <div class="container">
    <div
      v-check-visible-viewport="onVisibleInViewport"
      v-if="clItems && clItems.length"
      class="cl-list">
      <el-row
        v-if="heading"
        type="flex"
        justify="space-between"
        align="middle"
        class="list-header">
        <h4 class="heading">{{ heading }}</h4>
      </el-row>
      <flickity
        ref="flickity"
        :key="clItems.length"
        :options="flickityOptions">
        <div
          v-for="(clEpisode, index) in clItems"
          :key="index"
          :data-segment-uuid="clEpisode.uuid"
          class="carousel-container"
          data-test="list-continuelistening">
          <cl-item
            :bucket="bucketData"
            :media-size="bucket.media_size"
            :key="index"
            :episode="clEpisode"
            :redirect="redirect"
          />
        </div>
      </flickity>
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import Flickity from 'vue-flickity';
import PodcastCard from './PodcastCard';
import CategoryCard from './CategoryCard';
import CLItem from './CLItem';
import CarouselMixin from '../shared/carouselMixin';

export default {
  components: {
    Flickity,
    'podcast-card': PodcastCard,
    'category-card': CategoryCard,
    'cl-item': CLItem,
  },
  mixins: [CarouselMixin],
  props: {
    heading: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: true,
        freeScroll: true,
        pageDots: false,
        wrapAround: false,
        cellAlign: 'left',
        initialIndex: 0,
        contain: true,
        draggable: '>1',
        groupCells: true,
      },
      redirect: true,
      current_width: window && window.innerWidth,
      wheelScroll: false,
      is_mobile_width: false,
      arrow_hidden: false,
      drag_end: false,
      scroll_sensitivity: 200, // more means less sensitive
      bucketData: {},
    };
  },
  computed: {
    navigateToEnd: () => this.clItems.length && !this.loading,
    clItems() {
      return this.$store.getters.continueListeningPlaylist;
    },
  },
  watch: {
    clItems() {
      if (this.clItems.length) {
        this.dragStart();
        this.carouselSettled();
      }
    },
    bucket() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.removeResizeEvent();
  },
  methods: {
    init() {
      if (this.bucket.items && this.bucket.items.length) {
        this.bucketItems = this.bucket.items;
        this.bucketData = { ...this.bucket };
        this.bucketData.items = [];
        this.bucketData.position = this.$vnode.key;
        this.bucketData.items_count = this.bucket.items.length;

        this.dragStart();
        this.carouselSettled();
        this.arrowVisibility();
      }
    },
    dragStart() {
      this.$nextTick().then(() => {
        this.$refs.flickity.on('dragStart', () => {
          this.dragEnd = false;
          this.redirect = false;
        });
      }).catch((err) => { log.warn(err.message); });
    },
    dragEnd() {
      this.$nextTick().then(() => {
        this.$refs.flickity.on('dragEnd', () => {
          this.dragEnd = true;
        });
      }).catch((err) => { log.warn(err.message); });
    },
    bindMouseWheelEvent() {
      if (this.$refs.flickity) {
        this.$refs.flickity.$el.addEventListener('wheel', this.mouseScroll);
      } else {
        log.info('Flickity Not Yet Rendered');
      }
    },
    removeMouseWheelEvent() {
      if (this.$refs.flickity) {
        this.$refs.flickity.$el.removeEventListener('wheel', this.mouseScroll);
      } else {
        log.info('Flickity event does not exists');
      }
    },
    mouseScroll(e) {
      if (Math.abs(e.deltaY) > 0) {
        return;
      }
      e.preventDefault();
      if (e.deltaX / this.scroll_sensitivity > 0) {
        this.$refs.flickity.next();
      } else if (e.deltaX / this.scroll_sensitivity < 0) {
        this.$refs.flickity.previous();
      }
    },
    carouselSettled() {
      this.$nextTick().then(() => {
        this.$refs.flickity.on('settle', () => {
          this.triggerSegmentContentViewedEvent();
          log.info('Settled');
          this.redirect = true;
        });
      }).catch((err) => { log.warn(err.message); });
    },
    selectCell() {
      log.info('Selected');
      // this.flickityOptions.initialIndex = this.podcasts.length - this.podcast_offset;
      setTimeout(() => {
        this.$refs.flickity.selectCell(this.clItems.length - this.podcast_offset, false, true);
        this.scrollPodcasts();
      }, 10);
    },
    scrollPodcasts() {
      this.$nextTick().then(() => {
        this.$refs.flickity.on('scroll', (event) => {
          log.info(`Event Value: ${event}`);
          if (event >= 0.9) {
            this.$emit('scroll-right');
          }
        });
      }).catch((err) => { log.warn(err.message); });
    },
    arrowVisibility() {
      this.checkWindowSizes();
      window.addEventListener('resize', this.checkWindowSizes);
    },
    removeResizeEvent() {
      window.removeEventListener('resize', this.checkWindowSizes);
    },
    checkWindowSizes() {
      this.$nextTick().then(() => {
        if (!this.$refs.flickity) return;
        const pl = this.$el.querySelector('.podcast-list');
        const pc = this.$el.querySelector('.podcast-card');
        if (!pl || !pc) return;

        const a = pl.clientWidth;
        const b = pc.clientWidth;
        const c = Math.floor(a / b);
        if (this.bucketItems.length <= c) {
          this.hideArrows();
          this.removeMouseWheelEvent();
        } else {
          this.showArrows();
          this.bindMouseWheelEvent();
        }
      });
    },
    hideArrows() {
      const a = this.$el.querySelector('.flickity-button.next');
      const b = this.$el.querySelector('.flickity-button.previous');
      if (a) this.$el.querySelector('.flickity-button.next').className += ' d-none';
      if (b) this.$el.querySelector('.flickity-button.previous').className += ' d-none';
    },
    showArrows() {
      const elem = this.$el.querySelectorAll('.flickity-button.next,.flickity-button.previous');
      if (!elem[0] || !elem[1]) return;
      if (elem[0].classList.contains('d-none')) {
        this.$el.querySelector('.flickity-button.next').classList.remove('d-none');
      }
      if (elem[1].classList.contains('d-none')) {
        this.$el.querySelector('.flickity-button.previous').classList.remove('d-none');
      }
    },
    onSelectionToggle(podcast) {
      this.$emit('onSelect', podcast);
    },
    gotoPage(link) {
      if (link) this.$router.push(link);
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";
.cl-list {
  .list-header {
    // margin-top:56px;
    margin-bottom:16px;
    h4 {
      margin: 0 0 !important;
    }
  }
}
@media (max-width: 1024px) {
  .cl-list {
    .list-header {
      margin-top:30px;
    }
  }
}
@media(max-width: 567px) {
  .cl-list {
    .list-header {
      margin-top:25px;
    }
  }
  .flickity-button {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/CLList.vue